<template>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Amazon Seller Central Configuration</h4>
    </div>
    <div class="card-body">
      <alert-box type="danger" v-if="store.status === 'creating'">
        <div class='text-center'>
          Please wait for us to review the application. This may takes 1-2 business days.
        </div>
      </alert-box>
      <div class="table-responsive">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="font-bold">Amazon Seller ID</td>
              <td>
                <span>{{ store.configuration.amazonSellerId }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-bold">MWS Auth Token</td>
              <td>
                <span>{{ store.configuration.mwsAuthToken }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-bold">Amazon Store ID</td>
              <td>
                <span>{{ store.configuration.storeId }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="currentRole === 'admin' && store.status === 'creating'">
        <input-text
          type="text"
          name="amazonStoreId"
          label="Amazon Seller ID"
          placeholder=""
          :value="form.amazonStoreId"
          :errors="error.amazonStoreId"
          :required="true"
          @input="value => setField({ key: 'amazonStoreId', value })"
        />

        <div class="mt-3 text-right">
          <form-button
            type="primary"
            input-type="button"
            :disabled="formLoading"
            :loading="formLoading"
            text="APPROVE"
            :click="() => approveAmazonStore()"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters, mapActions } from "vuex";
  import _ from 'lodash'

  import InputText from "@/components/Form/InputText";
  import FormButton from "@/components/Form/FormButton";
  import AlertBox from '@/components/Misc/AlertBox';

  export default {
    name: "AmazonSellerCentralConfiguration",
    props: ["store"],
    components: {
      InputText,
      FormButton,
      AlertBox,
    },
    beforeMount() {
      this.clearForm();
    },
    computed: {
      ...mapGetters({
        user: "auth/user",
        formLoading: "store/formLoading",
        form: "store/form",
        error: 'store/error',
      }),
      currentUser() {
        return this.user || {};
      },
      currentRole() {
        return this.currentUser.role;
      },
    },
    methods: {
      ...mapActions({
        setField: "store/setField",
        clearForm: "store/clearForm",
        approveAmazonStore: "store/approveAmazonStore",
      }),
    }
  };
</script>
